import { userShipmentsPath } from "~/routes";
import { createSearchListStore } from "./create-search-list-store";

export const useShipmentSearchStore = createSearchListStore({
  id: "shipmentSearch",
  path: userShipmentsPath,
  itemsKey: "shipments",
  filters: [
    { key: "q", type: "string" },
    { key: "states", type: "stringArray", persist: true },
    { key: "receiverIds", type: "idArray", persist: true },
    { key: "transporterIds", type: "idArray", persist: true },
    { key: "estimatedShipBeginDate", type: "date" },
    { key: "estimatedShipEndDate", type: "date" },
    { key: "shippedBeginDate", type: "date" },
    { key: "shippedEndDate", type: "date" },
  ],
});
